import ResponsiveDialogActions from 'app/shared-components/layout/dialog/ResponsiveDialogActions';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ResponsiveDialog from 'app/shared-components/layout/dialog/ResponsiveDialog';
import { useTranslation } from 'react-i18next';
import { Button, DialogContent, DialogTitle } from '@mui/material';

interface WarningModalProps {
  isLoading: boolean;
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void; // This can be used for delete or any other actions
  modalHeader?: string;
  children?: React.ReactNode;
  continueButtonText?: string;
}

const WarningModal = ({
  isLoading,
  isOpen,
  onClose,
  onContinue,
  modalHeader,
  children,
  continueButtonText,
}: WarningModalProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <ResponsiveDialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ cursor: isLoading ? 'progress' : 'inherit' }}
    >
      <DialogTitle
        id="alert-dialog-title"
        color="error.main"
        sx={{
          fontSize: '24px',
          p: '24px',
          pb: '16px',
        }}
      >
        {modalHeader}
      </DialogTitle>
      <DialogContent sx={{ m: 0, fontWeight: 'bold' }}>{children}</DialogContent>
      <ResponsiveDialogActions sx={{ p: '24px', m: 0, flexFlow: 'column-reverse' }}>
        <Button variant="outlined" disabled={isLoading} onClick={onClose}>
          {t('cancel')}
        </Button>
        <Button variant="contained" disabled={isLoading} onClick={onContinue} color="error">
          <DeleteOutlineIcon sx={{ mr: '8px', display: { xs: 'none', sm: 'inline-flex' } }} />
          {continueButtonText}
        </Button>
      </ResponsiveDialogActions>
    </ResponsiveDialog>
  );
};

export default WarningModal;
